import { buildPatch } from 'api/builders';

export const update = ({
  nodeId, menuId, locationId, dispatch,
}) => buildPatch({
  url: `sign_up/api/menus/${menuId}/nodes/${nodeId}?location_id=${locationId}`,
  dispatch,
});
